import { Box } from '@npco/zeller-design-system'
import { DownloadMessage } from 'features/StartupModals/SetupFlow/components/DownloadMessage/DownloadMessage'

import { ReactComponent as ArrowBadge } from 'assets/svg/setup-flow/arrow.svg'
import { ReactComponent as QRCode } from 'assets/svg/setup-flow/download-QR-code.svg'

export const DownloadLinkTablet = () => {
  return (
    <Box
      data-testid="download-link-tablet"
      position="absolute"
      right="25%"
      top={{
        XS: 'calc((100vw - 32px) / 3.4 - 85px)',
        MD: 'calc(720px / 3.4 - 85px)',
      }}
    >
      <QRCode />

      <Box position="absolute" bottom="156px" right="-70px">
        <ArrowBadge />
      </Box>

      <Box position="absolute" top="-8px" right="-160px" maxWidth="162px">
        <DownloadMessage />
      </Box>
    </Box>
  )
}
